import { render, staticRenderFns } from "./dialDetail.vue?vue&type=template&id=0bbbd73d&scoped=true&"
import script from "./dialDetail.vue?vue&type=script&lang=js&"
export * from "./dialDetail.vue?vue&type=script&lang=js&"
import style0 from "./dialDetail.vue?vue&type=style&index=0&id=0bbbd73d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbd73d",
  null
  
)

export default component.exports